<div class="card" [ngClass]="{ 'disabled': !card.isEntitled }">
  <div class="subtitle">
    <em *ngIf="!card.isEntitled" class="icon-locked"></em>
    {{card.subtitle}}
  </div>
  <div class="title">{{card.title}}</div>
  <div class="description">{{card.description}}</div>
  <div class="date" *ngIf="card.date">{{card.date | date: 'MMM dd, yyyy':'UTC'}}</div>
</div>
